import React from 'react';
import darkThemeTokens from '@volvo-cars/ui-design-tokens/build/web/volvo-dark/tokens-storybook.json';
import lightThemeTokens from '@volvo-cars/ui-design-tokens/build/web/volvo/tokens-storybook.json';
import { Block, Flex, Spacer, Text, useTheme } from 'vcc-ui';

const themeTokens = {
  volvo: lightThemeTokens,
  'volvo-dark': darkThemeTokens,
};

function last(list) {
  return list.slice(-1)[0];
}

const Color = ({ name, value, comment }) => (
  <Flex extend={{ width: 120, marginRight: 16 }}>
    <Block extend={{ background: value, width: 120, height: 120 }} />
    <Text>{name}</Text>
    <Text variant="bates">{value}</Text>
    {comment && <Text variant="bates">{comment}</Text>}
    <Spacer />
  </Flex>
);

export default function Colors() {
  const { name } = useTheme();
  const colors = themeTokens[name].color;
  return (
    <>
      <Spacer size={4} />
      <Flex extend={{ flexDirection: 'row', flexWrap: 'wrap' }}>
        <Flex>
          <Text variant="hillary">Brand</Text>
          <Text>
            <code>theme.color.brand</code>
          </Text>
          <Spacer />
          {Object.keys(colors.brand).map((key) => {
            const color = colors.brand[key];
            return (
              <Color
                key={color.name}
                name={last(color.path)}
                value={color.value}
                comment={color.comment}
              />
            );
          })}
        </Flex>
        <Spacer size={2} />
        <Flex>
          <Text variant="hillary">Background</Text>
          <Text>
            <code>theme.color.background</code>
          </Text>
          <Spacer />
          <Flex extend={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            {Object.keys(colors.background).map((key) => {
              const color = colors.background[key];
              return (
                <Color
                  key={color.name}
                  name={last(color.path)}
                  value={color.value}
                  comment={color.comment}
                />
              );
            })}
          </Flex>
        </Flex>
      </Flex>
      <Spacer size={2} />
      <Text variant="hillary">Foreground</Text>
      <Text>
        <code>theme.color.foreground</code>
      </Text>
      <Spacer />
      <Flex extend={{ flexDirection: 'row', flexWrap: 'wrap' }}>
        {Object.keys(colors.foreground).map((key) => {
          const color = colors.foreground[key];
          if (color.deprecated) {
            return;
          }
          return (
            <Color
              key={color.name}
              name={last(color.path)}
              value={color.value}
              comment={color.comment}
            />
          );
        })}
      </Flex>
      <Spacer size={2} />
      <Text variant="hillary">Ornament</Text>
      <Text>
        <code>theme.color.ornament</code>
      </Text>
      <Spacer />
      <Flex extend={{ flexDirection: 'row', flexWrap: 'wrap' }}>
        {Object.keys(colors.ornament).map((key) => {
          const color = colors.ornament[key];
          return (
            <Color
              key={color.name}
              name={last(color.path)}
              value={color.value}
              comment={color.comment}
            />
          );
        })}
      </Flex>
    </>
  );
}
